import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective, TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';

import { VariableBlockComponent } from '../../../../../shared/components/variable-block/variable-block.component';

interface TopicArea {
  variable: string[];
  key: string;
  valueDE?: string;
  valueEN?: string;
}

@Component({
  selector: 'app-variable-topicarea-container',
  imports: [
    MatIcon,
    CommonModule,
    FormsModule,
    MatExpansionModule,
    MatTabsModule,
    TranslocoModule,
    TranslocoDirective,
    VariableBlockComponent,
  ],
  templateUrl: './variable-topicarea-container.component.html',
})
export class VariableTopicareaContainerComponent {
  @Input() headline!: string;
  @Input() icon!: string;
  @Input() description!: string;

  topicAreas: TopicArea[] = [
    {
      key: 'Compliance',
      variable: [
        'COAGGContactMail',
        'COAGGContactName',
        'COContactMail',
        'COContactName',
        'COWhistleblowing',
      ],
    },
    {
      key: 'CyberSecurity',
      variable: [
        'CyberIncidentCSContactMail',
        'CyberIncidentCSContactName',
        'CyberIncidentExample',
        'DPContactMail',
        'DPContactName',
        'LinkFileXchange',
        'PasswordManagerName',
        'PasswordManagerTip',
        'ReportPhishing',
        'SecurityEmail',
        'SecurityJobName',
        'SecurityName',
      ],
    },
    {
      key: 'DataProtection',
      variable: [
        'CyberIncidentCSContactMail',
        'CyberIncidentCSContactName',
        'DPContactMail',
        'DPContactName',
        'DPContactWay',
        'DPIncidentExample',
        'LinkFileXchange',
      ],
    },
    {
      key: 'OccupationalSafety',
      variable: [],
    },
  ];
}
